import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { ActiveCartService } from '@spartacus/core';
import { MiniCartComponent } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { CartService } from '../cart.service';
import { MiniEkCartService } from '../mini-ekcart.service';

@Component({
  selector: 'app-mini-ekcart',
  templateUrl: './mini-ekcart.component.html',
  styleUrls: ['./mini-ekcart.component.scss'],
})
export class MiniEkcartComponent extends MiniCartComponent implements AfterViewChecked {
  constructor(
    protected activeCartService: ActiveCartService,
    public miniEkCartService: MiniEkCartService,
    public cartService: CartService
  ) {
    super(activeCartService);
  }
  ngAfterViewChecked(): void {
    const el = document.querySelector("main");
    console.log(el);
    el?.setAttribute('style',"padding: 0");
    document.getElementsByClassName('header-theme')[0].setAttribute('style', "display: block");
  }
  
  totalItems$: Observable<number> = this.miniEkCartService.getQuantity();
}
